import {mapActions, mapGetters} from "vuex";

export default {
    data() {
        return {
            selectedDbCounterpartyId: null,
        };
    },
    computed:{
        ...mapGetters({
            registryList:'npRegistry/registryList',
            npCounterparties: 'npAutomation/npCounterparties',
        }),
        counterpartyOptions() {
            if (!Array.isArray(this.npCounterparties)) {
                return [];
            }
            return this.npCounterparties.map(cp => ({
                value: cp.id,
                text: cp.phone ? `${cp.name} (${cp.phone})` : (cp.name || `#${cp.id}`),
            }));
        }
    },
    watch: {
        selectedDbCounterpartyId(next) {
            if (next) {
                this.refreshRegistryList();
            }
        },
        npCounterparties() {
            this.initCounterpartySelection();
        }
    },
    created() {
        this.getNpCounterparties().then(() => {
            this.initCounterpartySelection();
            if (this.selectedDbCounterpartyId) {
                this.refreshRegistryList();
            }
        });
    },
    methods:{
        initCounterpartySelection() {
            if (this.selectedDbCounterpartyId) {
                return;
            }
            if (!Array.isArray(this.npCounterparties) || !this.npCounterparties.length) {
                return;
            }
            const defaultCp = this.npCounterparties.find(cp => cp.is_default) || this.npCounterparties[0];
            this.selectedDbCounterpartyId = defaultCp?.id || null;
        },
        refreshRegistryList() {
            if (!this.selectedDbCounterpartyId) {
                return;
            }
            this.getRegistryList({ db_counterparty_id: this.selectedDbCounterpartyId });
        },
        closePopup(){
            this.$emit('closePopup')
        },
        createNewRegister(){
            if (!this.selectedDbCounterpartyId) {
                this.$toasted?.error('Оберіть контрагента (відправника)', { duration: 4000 });
                return;
            }
            this.$emit('createNewRegister', { db_counterparty_id: this.selectedDbCounterpartyId })
            this.$emit('closePopup')
        },
        addToRegister(){
            if (!this.selectedDbCounterpartyId) {
                this.$toasted?.error('Оберіть контрагента (відправника)', { duration: 4000 });
                return;
            }
            this.$emit('addToRegister', { db_counterparty_id: this.selectedDbCounterpartyId })
            this.$emit('closePopup')
        },
        ...mapActions({
            getRegistryList:'npRegistry/getRegistryList',
            getNpCounterparties: 'npAutomation/getNpCounterparties',
        })
    }
}
